import axios from "axios"
import { RecaptchaDto } from "../models/ReCaptchaDto.model";

export const googleResponseCaptcha = async (response: RecaptchaDto) => {
    return axios.post('api/googleCaptcha/GoogleResponseCaptcha',response)
    .catch(err => err);
    
}